export default class ExpertListing {
    constructor($expertlist) {
        this.$list = $expertlist;
        this.$info = this.$list.querySelector('[data-expert-info]');
        this.$items = this.$list.querySelectorAll('[data-expert-item]');
        this.$triggerPrev = this.$list.querySelectorAll('[data-trigger-prev]');
        this.$triggerNext = this.$list.querySelectorAll('[data-trigger-next]');

        this.$activeItemIndex = 0;

        const image = this.$list.dataset.expertFirstBg;
        this.$list.style.setProperty('--background-image', "url('" + image + "')");

        this.toggleInfo = this.toggleInfo.bind(this);
        this.slideInfo = this.slideInfo.bind(this);

        this.$items.forEach($trigger => $trigger.addEventListener('mouseover', this.toggleInfo));
        this.$items.forEach($trigger => $trigger.addEventListener('touchend', this.toggleInfo));
        this.$triggerPrev.forEach($trigger => $trigger.addEventListener('click', this.slideInfo));
        this.$triggerNext.forEach($trigger => $trigger.addEventListener('click', this.slideInfo));

        window.setInterval(function(items){
            var activeItem = document.getElementsByClassName('expert-fields__item--active')[0];
            var nextItem = activeItem.nextElementSibling ? activeItem.nextElementSibling : items[0];

            var hovered = false;
            items.forEach(function ($item) {
                hovered = hovered ? hovered : $item.parentElement.querySelector(':hover') === $item;
            })
            if (!hovered) {
                const mouseoverEvent = new Event('mouseover');
                nextItem.dispatchEvent(mouseoverEvent);
            }
        }, 5000, this.$items);
    }

    toggleInfo(e) {
        e.preventDefault();
        // If not an item (but child) then return
        if (!e.target.hasAttribute('data-expert-item')) return;

        this.changeView(e.target);
    }

    changeView(target) {
        this.$title = this.$info.querySelector('[data-expert-title]');
        this.$text = this.$info.querySelector('[data-expert-text]');
        this.$button = this.$info.querySelector('[data-expert-button]');
        const title = target.dataset.expertTitleText;
        const text = target.dataset.expertTextText;
        const buttonText = target.dataset.expertButtonText;
        const buttonLink = target.dataset.expertButtonLink;
        const image = target.dataset.expertImageBg;

        // if the same item is hovered then return
        if (title === this.$title.innerHTML && text === this.$text.innerHTML) return;

        this.$title.style.opacity = 0;
        this.$text.style.opacity = 0;
        this.$button.style.opacity = 0;
        setTimeout(function (args) {
            var thistitle = args[0];
            var thistext = args[1];
            var thisbutton = args[2];

            // Load new content
            thistitle.innerHTML = title;
            thistitle.style.opacity = 1;

            thistext.innerHTML = text;
            thistext.style.opacity = 1;

            thisbutton.innerHTML = buttonText;
            thisbutton.href = buttonLink;
            thisbutton.style.opacity = 1;
        }, 280, [this.$title, this.$text, this.$button]);

        this.$list.style.setProperty('--background-image', "url('" + image + "')");

        this.$items.forEach($item => $item.classList.remove('expert-fields__item--active'));
        target.classList.add('expert-fields__item--active');
    }

    slideInfo(e) {
        this.$activeItemIndex = e.target.hasAttribute('data-trigger-prev')
            ? this.$activeItemIndex + 1
            : this.$activeItemIndex - 1;

        if (this.$activeItemIndex < 0) {
            this.$activeItemIndex = this.$items.length - 1;
        }

        if (this.$activeItemIndex === this.$items.length) {
            this.$activeItemIndex = 0;
        }

        let activeItem = this.$items[this.$activeItemIndex];

        this.changeView(activeItem);
    }

}